<ng-container *ngIf="state$ | async; let state">
    <ng-container *ngIf="validity$ | async; let validity">
        <form>
            <ng-template [ngIf]="isIndividual(state.customer)">
                <div class="zas-row">
                    <div class="zas-main-col">
                        <div class="zas-inner-table">
                            <zbd-input
                                type="select"
                                name="individualSalutation"
                                label="Anrede"
                                class="zas-inner-col-left"
                                [entity]="state.customer"
                                property="Salutation"
                                [updateFn]="
                                    salutationUpdateFn(
                                        state.consultationProcess
                                    )
                                "
                                [validity]="validity"
                                [locked]="isSalutationLocked(state.customer)"
                            >
                                <option
                                    *ngFor="
                                        let value of getKeys(
                                            ZASConstants.SalutationSelectorTable
                                        )
                                    "
                                    [value]="value"
                                >
                                    {{
                                        ZASConstants.SalutationSelectorTable[
                                            value
                                        ]
                                    }}
                                </option>
                            </zbd-input>
                            <zbd-input
                                type="select"
                                name="academicDegree"
                                label="Akademischer Titel"
                                class="zas-inner-col-right"
                                [entity]="state.customer"
                                property="AcademicDegree"
                                [updateFn]="customerUpdateFn(state.customer)"
                                [locked]="isLocked(state.customer)"
                            >
                                <option value="">kein</option>
                                <option
                                    *ngFor="
                                        let value of getKeys(
                                            ZASConstants.AcademicDegreeTable
                                        )
                                    "
                                    [value]="value"
                                >
                                    {{
                                        ZASConstants.AcademicDegreeTable[value]
                                    }}
                                </option>
                            </zbd-input>
                        </div>
                    </div>
                    <zbd-input
                        type="date"
                        name="birthdate"
                        rel-thres-year="18"
                        label="Geburtsdatum"
                        class="zas-main-col"
                        [entity]="state.customer"
                        property="Birthdate"
                        [updateFn]="customerUpdateFn(state.customer)"
                        [validity]="validity"
                        [locked]="isLocked(state.customer)"
                    ></zbd-input>
                </div>
                <div class="zas-row">
                    <zbd-input
                        type="text"
                        name="firstName"
                        label="Vorname"
                        class="zas-main-col"
                        [entity]="state.customer"
                        property="FirstName"
                        [updateFn]="customerUpdateFn(state.customer)"
                        [validity]="validity"
                        [locked]="isLocked(state.customer)"
                    ></zbd-input>
                    <zbd-input
                        type="text"
                        name="lastName"
                        label="Nachname"
                        class="zas-main-col"
                        [entity]="state.customer"
                        property="LastName"
                        [updateFn]="customerUpdateFn(state.customer)"
                        [validity]="validity"
                        [locked]="isLocked(state.customer)"
                    ></zbd-input>
                </div>
                <div class="zas-row">
                    <zbd-input
                        type="select"
                        name="titleOfNobility"
                        label="Adelstitel"
                        class="zas-main-col"
                        [entity]="state.customer"
                        property="TitleOfNobility"
                        [updateFn]="customerUpdateFn(state.customer)"
                        [locked]="isLocked(state.customer)"
                    >
                        <option value="">kein</option>
                        <option
                            *ngFor="
                                let value of getKeys(
                                    ZASConstants.TitleOfNobilityTable
                                )
                            "
                            [value]="value"
                        >
                            {{ ZASConstants.TitleOfNobilityTable[value] }}
                        </option>
                    </zbd-input>
                    <zbd-input
                        type="select"
                        name="nameParticle"
                        label="Vorsatz"
                        class="zas-main-col"
                        [entity]="state.customer"
                        property="NameParticle"
                        [updateFn]="customerUpdateFn(state.customer)"
                        [locked]="isLocked(state.customer)"
                    >
                        <option value="">kein</option>
                        <option
                            *ngFor="
                                let value of getKeys(
                                    ZASConstants.NameParticleTable
                                )
                            "
                            [value]="value"
                        >
                            {{ ZASConstants.NameParticleTable[value] }}
                        </option>
                    </zbd-input>
                    <zbd-input
                        type="select"
                        name="nameSuffix"
                        label="Zusatz"
                        class="zas-main-col"
                        [entity]="state.customer"
                        property="NameSuffix"
                        [updateFn]="customerUpdateFn(state.customer)"
                        [locked]="isLocked(state.customer)"
                    >
                        <option value="">kein</option>
                        <option
                            *ngFor="
                                let value of getKeys(
                                    ZASConstants.NameSuffixTable
                                )
                            "
                            [value]="value"
                        >
                            {{ ZASConstants.NameSuffixTable[value] }}
                        </option>
                    </zbd-input>
                </div>
            </ng-template>

            <ng-template [ngIf]="isCompany(state.customer)">
                <div class="zas-row">
                    <div class="zas-main-col">
                        <div class="zas-inner-table">
                            <zbd-input
                                type="select"
                                name="companySalutation"
                                label="Anrede"
                                class="zas-inner-col-left"
                                [entity]="state.customer"
                                property="Salutation"
                                [updateFn]="
                                    salutationUpdateFn(
                                        state.consultationProcess
                                    )
                                "
                                [validity]="validity"
                                [locked]="isSalutationLocked(state.customer)"
                            >
                                <option
                                    *ngFor="
                                        let value of getKeys(
                                            ZASConstants.SalutationSelectorTable
                                        )
                                    "
                                    [value]="value"
                                >
                                    {{
                                        ZASConstants.SalutationSelectorTable[
                                            value
                                        ]
                                    }}
                                </option>
                            </zbd-input>
                            <div class="zas-inner-col-right">
                                <!-- blank column-->
                            </div>
                        </div>
                    </div>
                    <div class="zas-main-col form-group">
                        <!-- blank column-->
                    </div>
                </div>
                <div class="zas-row">
                    <zbd-input
                        type="text"
                        name="companyName"
                        label="Name der Firma"
                        class="zas-main-col"
                        [entity]="state.customer"
                        property="Name"
                        [updateFn]="customerUpdateFn(state.customer)"
                        [validity]="validity"
                        [locked]="isLocked(state.customer)"
                        [securityFilter]="'light'"
                    ></zbd-input>
                    <div class="zas-main-col">
                        <div class="zas-inner-table">
                            <zbd-input
                                type="select"
                                name="legalForm"
                                label="Rechtsform"
                                class="zas-inner-col-left"
                                [entity]="state.customer"
                                property="LegalForm"
                                [updateFn]="customerUpdateFn(state.customer)"
                                [validity]="validity"
                                [locked]="isLocked(state.customer)"
                            >
                                <option value="" disabled></option>
                                <option
                                    *ngFor="
                                        let value of getKeys(
                                            ZASConstants.LegalFormTable
                                        )
                                    "
                                    [value]="value"
                                >
                                    {{ ZASConstants.LegalFormTable[value] }}
                                </option>
                            </zbd-input>
                            <div class="zas-inner-col-right"></div>
                        </div>
                    </div>
                </div>
                <div class="zas-row zas-headline-3">
                    Ansprechpartner der Firma
                </div>
                <div class="zas-row">
                    <div class="zas-main-col">
                        <div class="zas-inner-table">
                            <zbd-input
                                type="select"
                                name="contactSalutation"
                                label="Anrede"
                                class="zas-inner-col-left"
                                [entity]="state.customer"
                                property="ContactSalutation"
                                [updateFn]="customerUpdateFn(state.customer)"
                                [validity]="validity"
                                [locked]="isLocked(state.customer)"
                            >
                                <option value="" disabled></option>
                                <option
                                    *ngFor="
                                        let value of getKeys(
                                            ZASConstants.SalutationTable
                                        )
                                    "
                                    [value]="value"
                                >
                                    {{ ZASConstants.SalutationTable[value] }}
                                </option>
                            </zbd-input>
                            <div class="zas-inner-col-right form-group"></div>
                        </div>
                    </div>
                    <zbd-input
                        type="text"
                        name="contactName"
                        label="Vorname und Nachname"
                        class="zas-main-col"
                        [entity]="state.customer"
                        property="ContactName"
                        [updateFn]="customerUpdateFn(state.customer)"
                        [validity]="validity"
                        [locked]="isLocked(state.customer)"
                    ></zbd-input>
                </div>
            </ng-template>

            <div class="zas-row zas-headline-3">Adressdaten</div>
            <div class="zas-row">
                <zbd-input
                    type="checkbox"
                    name="isPostOfficeBox"
                    label="Postfach"
                    class="zas-main-col"
                    [entity]="state.address"
                    property="IsPostOfficeBox"
                    [updateFn]="persistence.updateAddress"
                    [locked]="isLocked(state.customer)"
                ></zbd-input>
            </div>
            <div class="zas-row">
                <zbd-input
                    type="select"
                    name="country"
                    label="Land"
                    class="zas-main-col"
                    [entity]="state.address"
                    property="Country"
                    [updateFn]="persistence.updateAddress"
                    [locked]="isLocked(state.customer)"
                    [validity]="validity"
                >
                    <option
                        *ngFor="let value of getKeys(ZASConstants.CountryTable)"
                        [value]="value"
                    >
                        {{ ZASConstants.CountryTable[value] }}
                    </option>
                </zbd-input>
                <div class="zas-main-col">
                    <div class="zas-inner-table">
                        <zbd-input
                            type="text"
                            name="zip"
                            label="PLZ"
                            class="col-xs-4 zas-inner-col-left"
                            [entity]="state.address"
                            property="Zip"
                            [updateFn]="persistence.updateAddress"
                            [validity]="validity"
                            [locked]="isLocked(state.customer)"
                        ></zbd-input>
                        <zbd-input
                            type="text"
                            name="city"
                            label="Ort"
                            class="col-xs-8 zas-inner-col-right"
                            [entity]="state.address"
                            property="City"
                            [updateFn]="persistence.updateAddress"
                            [validity]="validity"
                            [locked]="isLocked(state.customer)"
                        ></zbd-input>
                    </div>
                </div>
            </div>
            <div class="zas-row">
                <div class="zas-main-col">
                    <div
                        *ngIf="!state.address.IsPostOfficeBox"
                        class="zas-inner-table"
                    >
                        <zbd-input
                            type="text"
                            name="street"
                            label="Straße"
                            class="col-xs-8 zas-inner-col-left"
                            [entity]="state.address"
                            property="Street"
                            [updateFn]="persistence.updateAddress"
                            [validity]="validity"
                            [locked]="isLocked(state.customer)"
                            [securityFilter]="'light'"
                        ></zbd-input>
                        <zbd-input
                            type="text"
                            name="streetNumber"
                            label="Hausnr."
                            class="col-xs-4 zas-inner-col-right"
                            [entity]="state.address"
                            property="StreetNumber"
                            [updateFn]="persistence.updateAddress"
                            [validity]="validity"
                            [locked]="isLocked(state.customer)"
                        ></zbd-input>
                    </div>
                    <zbd-input
                        *ngIf="state.address.IsPostOfficeBox"
                        type="text"
                        name="postOfficeBoxNumber"
                        label="Postfachnummer"
                        [entity]="state.address"
                        property="PostOfficeBoxNumber"
                        [updateFn]="persistence.updateAddress"
                        [validity]="validity"
                        [locked]="isLocked(state.customer)"
                    ></zbd-input>
                </div>
                <zbd-input
                    type="text"
                    name="district"
                    label="Ortsteil"
                    class="zas-main-col"
                    [entity]="state.address"
                    property="District"
                    [updateFn]="persistence.updateAddress"
                    [locked]="isLocked(state.customer)"
                ></zbd-input>
            </div>
            <div class="zas-row">
                <zbd-input
                    type="text"
                    name="addressLine2"
                    label="Adresszusatz"
                    class="zas-main-col"
                    [entity]="state.address"
                    property="AddressLine2"
                    [updateFn]="persistence.updateAddress"
                    [locked]="isLocked(state.customer)"
                ></zbd-input>
                <div class="zas-main-col"></div>
            </div>
            <div class="zas-row zas-headline-3">Kontaktdaten</div>
            <div class="zas-row">
                <zbd-input
                    type="text"
                    name="phonePrivate"
                    label="Telefon (privat)"
                    class="zas-main-col"
                    [entity]="state.address"
                    property="PhonePrivate"
                    [updateFn]="persistence.updateAddress"
                    [locked]="isLocked(state.customer)"
                ></zbd-input>
                <zbd-input
                    type="text"
                    name="phoneBusiness"
                    label="Telefon (geschäftlich)"
                    class="zas-main-col"
                    [entity]="state.address"
                    property="PhoneBusiness"
                    [updateFn]="persistence.updateAddress"
                    [locked]="isLocked(state.customer)"
                ></zbd-input>
            </div>
            <div class="zas-row">
                <zbd-input
                    type="text"
                    name="phoneMobile"
                    label="Telefon (mobil)"
                    class="zas-main-col"
                    [entity]="state.address"
                    property="PhoneMobile"
                    [updateFn]="persistence.updateAddress"
                    [locked]="isLocked(state.customer)"
                ></zbd-input>
                <zbd-input
                    type="text"
                    name="telefax"
                    label="Telefax"
                    class="zas-main-col"
                    [entity]="state.address"
                    property="Telefax"
                    [updateFn]="persistence.updateAddress"
                    [locked]="isLocked(state.customer)"
                ></zbd-input>
            </div>
            <div class="zas-row">
                <zbd-input
                    type="text"
                    name="email"
                    label="E-Mail-Adresse"
                    class="zas-main-col"
                    [entity]="state.address"
                    property="EMail"
                    [updateFn]="persistence.updateAddress"
                    [locked]="isLocked(state.customer)"
                ></zbd-input>
                <div class="zas-main-col"></div>
            </div>
        </form>
    </ng-container>
</ng-container>
